import { useEffect, useState } from 'react';

import {
  CURRENT_PROJECT_CHANGE_EVENT,
  getActiveProjectId,
  isAllProjectsId,
} from '@/lib/utils/currentProject';

export const useActiveProject = () => {
  const [activeProjectId, setActiveProjectId] = useState(getActiveProjectId);

  useEffect(() => {
    const syncProject = () => {
      setActiveProjectId(getActiveProjectId());
    };

    window.addEventListener(CURRENT_PROJECT_CHANGE_EVENT, syncProject);
    return () => {
      window.removeEventListener(CURRENT_PROJECT_CHANGE_EVENT, syncProject);
    };
  }, []);

  return {
    activeProjectId,
    isAllProjects: isAllProjectsId(activeProjectId),
  };
};
